import { Box, Button, Heading } from '@chakra-ui/react'
import { PlusIcon } from '@icons'
import React from 'react'

interface CalendarSyncTileProps {
  icon: React.ReactNode
  title: string
  onClick?: () => void
}

const CalendarSyncTile: React.FC<CalendarSyncTileProps> = ({
  icon,
  title,
  onClick
}) => {
  return (
    <Box
      p="24px 32px 32px 32px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      borderRadius="8px"
      border="1px solid #E4E5E6"
      bg="#FFFFFF"
      cursor="pointer"
      onClick={onClick}
      minWidth="215px"
      width="100%"
      minHeight="180px"
      _hover={{
        bg: 'rgba(45, 84, 232, 0.04)'
      }}
    >
      <Box
        w="48px"
        h="48px"
        p="12px 12px 12px 12px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        borderRadius="8px"
        border="1px solid"
        borderColor="rgba(40, 40, 40, 0.05)"
        bg="#F9F9F9"
      >
        {icon}
      </Box>
      <Heading my="16px" size="small">
        {title}
      </Heading>
      <Button
        variant="ghost"
        display="flex"
        minH="32px"
        px="16px"
        py="4px"
        justifyContent="center"
        alignItems="center"
        borderRadius="8px"
        border="1px solid rgba(55, 60, 65, 0.14)"
        gap="8px"
        leftIcon={<PlusIcon />}
        _hover={{
          bg: 'rgba(45, 84, 232, 0.04)'
        }}
        _active={{
          bg: 'rgba(45, 84, 232, 0.10)'
        }}
      >
        Add calendar
      </Button>
    </Box>
  )
}

export default CalendarSyncTile
